// extracted by mini-css-extract-plugin
export default {"loginButton":"login_button_loginButton__yCiZv","cardFlipEffect":"login_button_cardFlipEffect__D5EKV"};